"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var OnClickOutside = function OnClickOutside(props) {
  var node = (0, _react.useRef)();
  var clickHandler = props.handleClickOutside,
      removeHandler = props.removeHandler;
  (0, _react.useEffect)(function () {
    if (typeof clickHandler === "function" && !removeHandler) {
      var handleOutsideClick = function handleOutsideClick(e) {
        if (node.current && node.current.contains(e.target)) {
          return;
        }

        clickHandler(e);
      };

      document.addEventListener("mousedown", handleOutsideClick);
      return function () {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }

    return _noop2["default"];
  }, [clickHandler, removeHandler]);
  return /*#__PURE__*/_react["default"].createElement(OnClickOutside.Wrapper, (0, _extends2["default"])({}, props, {
    ref: node
  }), props.children);
};

OnClickOutside.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-18n4g8v-0"
})(["width:", ";"], function (props) {
  return props.width ? props.width : "max-content";
});
OnClickOutside.propTypes = {
  width: _propTypes["default"].string,
  children: _propTypes["default"].node,
  handleClickOutside: _propTypes["default"].func.isRequired,
  removeHandler: _propTypes["default"].bool
};
OnClickOutside.defaultProps = {
  removeHandler: false
};
var _default = OnClickOutside; // USAGE:

/*
 *   <OnClickOutside handleClickOutside={handleClickOutside}>
 *     // your component here
 *   </OnClickOutside>
 *
 *   const handleClickOutside = {
 *     // handle outside click
 *   };
 */

exports["default"] = _default;